module.exports = __webpack_public_path__ + "static/media/instruments-english.3a3c5fb9.png";